export enum GridMode {
  FIRST_UP = 'FIRST_UP',
  FIRST_DOWN = 'FIRST_DOWN'
}
